import React, { useState } from 'react';

function DownloadButton({ downloaded, setDownloaded }) {
    const [downloadStatus, setDownloadStatus] = useState('not started');
    const [downloadProgress, setDownloadProgress] = useState(0);
    const downloadAPK = async () => {
        setDownloadStatus('downloading');
        const apiUrl = 'https://kosh-testing-app.s3.ap-south-1.amazonaws.com/app-release.apk';
        setDownloadStatus('started')
        let response = await fetch(apiUrl);
        if (!response.ok) {
            setDownloadStatus('failed');
            window.alert('Download failed! Please retry')
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const filename = 'kosh.apk';
        const contentLength = response.headers.get('content-length');
        const chunks = [];
        let downloadedBytes = 0;
        const reader = response.body.getReader();
        while (true) {
            const { done, value } = await reader.read();
            if (done) {
                break;
            }
            chunks.push(value);
            downloadedBytes += value.length;
            setDownloadProgress((downloadedBytes / contentLength) * 100);
        }
        const blob = new Blob(chunks);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setDownloadStatus('complete');
        setDownloaded(true)
        setDownloadProgress(0);
    };

    let downloadButtonText;
    if (downloadStatus == 'started') downloadButtonText = 'Downloading'
    else if (downloadStatus == 'not started' || !downloaded) downloadButtonText = 'Download'
    else if (downloadStatus == 'complete') downloadButtonText = 'Download Completed'
    return (
        <div style={{ width: '100%' }}>
            <button onClick={downloadAPK} style={{
                width: '98%', height: 34, fontSize: 16, fontWeight: 'bold', backgroundColor: downloaded ? 'rgb(232, 243, 255)' : '#01875f',
                borderWidth: 0, color: downloaded ? 'black' : 'white', borderRadius: 17,
            }} disabled={downloadStatus == 'started' || downloadStatus == 'complete'}>{downloadButtonText}{' '}{downloadProgress > 0 && `(  ${downloadProgress.toFixed(1)}%)`}</button>
        </div>
    );
}
export default DownloadButton;